import {Button} from "primereact/button";
import _ from "lodash";
import KeyMetricAutocomplete from "../dropdowns/KeyMetricAutocomplete";

const TwoColumnMetricTable = ({formik, name, title, disabled}) => {
    const handleAddRow = () => {
        const clonedData = _.cloneDeep(formik.values);

        if(!clonedData[name])
        {
            clonedData[name] = [];
        }

        clonedData[name].push({
            value: ""
        });

        formik.setValues(clonedData);
    }

    return (
        <div className="formgrid grid two-column-metric-table">
            <h1 className="col-12">{title}</h1>

            {(formik.values[name] || []).map((metric, index) => {
                const onChange = (event) => {
                    event.preventDefault();

                    const cloneTarget = _.cloneDeep(formik.values);

                    cloneTarget[name][index] = event?.value?.name;

                    formik.setValues(cloneTarget);
                }
                return (<div className="col-6" key={index}>
                    <KeyMetricAutocomplete type="any" name={`name[${index}]`} value={formik?.values[name][index]} onChange={onChange} disabled={disabled}/>
                </div>);
            })}

            <div className="col-12">
                <Button type="button" label="Add Metric" className="p-button-text" onClick={handleAddRow} visible={!disabled}/>
            </div>
        </div>
    );
}

export default TwoColumnMetricTable;
